import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

import NavLink from "./NavLink";

const HelperFormButtons = ({ formButtons }) => {
  const navigate = useNavigate();

  return formButtons.map((i, index) => (
    <Col key={i.route}>
      <NavLink
        onClick={() => navigate(i.route)}
        label={i.label}
        styles={index === 1 ? { float: "right" } : {}}
      />
    </Col>
  ));
};

export default HelperFormButtons;
